const TUI_KOREAN_LANGUAGE_ADDON_COMMERCE = {
  cardNumber: ['숫자', '카드번호'],
  cardExpiry: ['만료', '유효 기간:']
};
const TUI_KOREAN_LANGUAGE_ADDON_EDITOR = {
  colorSelectorModeNames: ['단색', '구배'],
  toolbarTools: {
    undo: '끄르다',
    redo: '다시 하다',
    font: '세례반',
    fontStyle: '글꼴 스타일',
    fontSize: '글꼴 크기',
    bold: '용감한',
    italic: '이탤릭체',
    underline: '밑줄',
    strikeThrough: '취소선',
    justify: '신이 옳다고 하다',
    justifyLeft: '왼쪽 정렬',
    justifyCenter: '중앙 정렬',
    justifyRight: '오른쪽으로 정렬',
    justifyFull: '전체를 정당화하다',
    list: '목록',
    indent: '톱니 모양',
    outdent: '내어쓰기',
    unorderedList: '순서 없는 목록',
    orderedList: '정렬된 목록',
    quote: '인용하다',
    foreColor: '색상',
    backColor: '배경색',
    hiliteColor: '하이라이트 색상',
    clear: '분명한',
    link: '링크',
    attach: '파일 첨부',
    tex: 'TeX 삽입',
    code: '암호',
    image: '이미지 삽입',
    insertHorizontalRule: '수평선 삽입',
    superscript: '어깨 기호',
    subscript: '아래첨자',
    insertTable: '테이블 삽입',
    insertGroup: '그룹 삽입',
    hiliteGroup: '하이라이트 그룹',
    removeGroup: '그룹 제거',
    insertAnchor: '앵커 삽입',
    mergeCells: '셀 병합',
    splitCells: '세포 분할',
    rowsColumnsManaging: '행과 열 관리',
    cellColor: '셀 색상',
    setDetails: '세부',
    removeDetails: '세부 정보 제거'
  },
  editorEditLink: {
    urlExample: 'example.com',
    anchorExample: '닻'
  },
  editorTableCommands: [['열을 삽입하기 전에', '다음에 열 삽입'], ['행을 삽입하기 전에', '행 삽입'], ['열 삭제', '행 삭제']],
  editorCodeOptions: ['텍스트의 코드', '블록 내 코드'],
  editorFontOptions: {
    small: '작은',
    large: '크기가 큰',
    normal: '정상',
    title: '제목',
    subtitle: '부제'
  }
};
const TUI_KOREAN_LANGUAGE_ADDON_TABLE = {
  showHideText: '표시 또는 숨기기',
  paginationTexts: {
    pages: '페이지',
    linesPerPage: '페이지당 줄 수',
    of: '~의'
  }
};
const TUI_KOREAN_LANGUAGE_COUNTRIES = {
  AD: 'Andorra',
  AE: 'United Arab Emirates',
  AF: 'Afghanistan',
  AG: 'Antigua & Barbuda',
  AI: 'Anguilla',
  AL: 'Albania',
  AM: 'Armenia',
  AO: 'Angola',
  AR: 'Argentina',
  AT: 'Austria',
  AU: 'Australia',
  AW: 'Aruba',
  AZ: 'Azerbaijan',
  BA: 'Bosnia & Herzegovina',
  BB: 'Barbados',
  BD: 'Bangladesh',
  BE: 'Belgium',
  BF: 'Burkina Faso',
  BG: 'Bulgaria',
  BH: 'Bahrain',
  BI: 'Burundi',
  BJ: 'Benin',
  BL: 'St. Barthélemy',
  BM: 'Bermuda',
  BN: 'Brunei',
  BO: 'Bolivia',
  BQ: 'Caribbean Netherlands',
  BR: 'Brazil',
  BS: 'Bahamas',
  BT: 'Bhutan',
  BW: 'Botswana',
  BY: 'Belarus',
  BZ: 'Belize',
  CA: 'Canada',
  CD: 'Congo - Kinshasa',
  CF: 'Central African Republic',
  CG: 'Congo - Brazzaville',
  CH: 'Switzerland',
  CI: 'Côte d’Ivoire',
  CL: 'Chile',
  CM: 'Cameroon',
  CN: 'China',
  CO: 'Colombia',
  CR: 'Costa Rica',
  CU: 'Cuba',
  CV: 'Cape Verde',
  CW: 'Curaçao',
  CY: 'Cyprus',
  CZ: 'Czechia',
  DE: 'Germany',
  DJ: 'Djibouti',
  DK: 'Denmark',
  DM: 'Dominica',
  DO: 'Dominican Republic',
  DZ: 'Algeria',
  EC: 'Ecuador',
  EE: 'Estonia',
  EG: 'Egypt',
  ER: 'Eritrea',
  ES: 'Spain',
  ET: 'Ethiopia',
  FI: 'Finland',
  FJ: 'Fiji',
  FK: 'Falkland Islands',
  FM: 'Federated States of Micronesia',
  FR: 'France',
  GA: 'Gabon',
  GB: 'United Kingdom',
  GD: 'Grenada',
  GE: 'Georgia',
  GF: 'French Guiana',
  GH: 'Ghana',
  GI: 'Gibraltar',
  GL: 'Greenland',
  GM: 'Gambia',
  GN: 'Guinea',
  GP: 'Guadeloupe',
  GQ: 'Equatorial Guinea',
  GR: 'Greece',
  GT: 'Guatemala',
  GW: 'Guinea-Bissau',
  GY: 'Guyana',
  HK: 'Hong Kong',
  HN: 'Honduras',
  HR: 'Croatia',
  HT: 'Haiti',
  HU: 'Hungary',
  ID: 'Indonesia',
  IE: 'Ireland',
  IL: 'Israel',
  IN: 'India',
  IQ: 'Iraq',
  IR: 'Iran',
  IS: 'Iceland',
  IT: 'Italy',
  JM: 'Jamaica',
  JO: 'Jordan',
  JP: 'Japan',
  KE: 'Kenya',
  KG: 'Kyrgyzstan',
  KH: 'Cambodia',
  KM: 'Comoros',
  KN: 'St. Kitts & Nevis',
  KP: 'North Korea',
  KR: 'South Korea',
  KW: 'Kuwait',
  KY: 'Cayman Islands',
  KZ: 'Kazakhstan',
  LA: 'Laos',
  LB: 'Lebanon',
  LC: 'St. Lucia',
  LI: 'Liechtenstein',
  LK: 'Sri Lanka',
  LR: 'Liberia',
  LS: 'Lesotho',
  LT: 'Lithuania',
  LU: 'Luxembourg',
  LV: 'Latvia',
  LY: 'Libya',
  MA: 'Morocco',
  MC: 'Monaco',
  MD: 'Moldova',
  ME: 'Montenegro',
  MF: 'St. Martin',
  MG: 'Madagascar',
  MK: 'North Macedonia',
  ML: 'Mali',
  MM: 'Myanmar (Burma)',
  MN: 'Mongolia',
  MO: 'Macao',
  MQ: 'Martinique',
  MR: 'Mauritania',
  MS: 'Montserrat',
  MT: 'Malta',
  MU: 'Mauritius',
  MV: 'Maldives',
  MW: 'Malawi',
  MX: 'Mexico',
  MY: 'Malaysia',
  MZ: 'Mozambique',
  NA: 'Namibia',
  NC: 'New Caledonia',
  NE: 'Niger',
  NG: 'Nigeria',
  NI: 'Nicaragua',
  NL: 'Netherlands',
  NO: 'Norway',
  NP: 'Nepal',
  NZ: 'New Zealand',
  OM: 'Oman',
  PA: 'Panama',
  PE: 'Peru',
  PF: 'French Polynesia',
  PG: 'Papua New Guinea',
  PH: 'Philippines',
  PK: 'Pakistan',
  PL: 'Poland',
  PT: 'Portugal',
  PW: 'Palau',
  PY: 'Paraguay',
  QA: 'Qatar',
  RE: 'Réunion',
  RO: 'Romania',
  RS: 'Serbia',
  RU: 'Russia',
  RW: 'Rwanda',
  SA: 'Saudi Arabia',
  SB: 'Solomon Islands',
  SC: 'Seychelles',
  SD: 'Sudan',
  SE: 'Sweden',
  SG: 'Singapore',
  SH: 'St. Helena',
  SI: 'Slovenia',
  SK: 'Slovakia',
  SL: 'Sierra Leone',
  SM: 'San Marino',
  SN: 'Senegal',
  SO: 'Somalia',
  SR: 'Suriname',
  ST: 'São Tomé & Príncipe',
  SV: 'El Salvador',
  SX: 'Sint Maarten',
  SY: 'Syria',
  SZ: 'Eswatini',
  TC: 'Turks & Caicos Islands',
  TD: 'Chad',
  TG: 'Togo',
  TH: 'Thailand',
  TJ: 'Tajikistan',
  TL: 'Timor-Leste',
  TM: 'Turkmenistan',
  TN: 'Tunisia',
  TO: 'Tonga',
  TR: 'Türkiye',
  TT: 'Trinidad & Tobago',
  TW: 'Taiwan',
  TZ: 'Tanzania',
  UA: 'Ukraine',
  UG: 'Uganda',
  US: 'United States',
  UY: 'Uruguay',
  UZ: 'Uzbekistan',
  VC: 'St. Vincent & Grenadines',
  VE: 'Venezuela',
  VG: 'British Virgin Islands',
  VN: 'Vietnam',
  VU: 'Vanuatu',
  WS: 'Samoa',
  XK: 'Kosovo',
  YE: 'Yemen',
  YT: 'Mayotte',
  ZA: 'South Africa',
  ZM: 'Zambia',
  ZW: 'Zimbabwe',
  AC: 'Ascension Island',
  AS: 'American Samoa',
  AX: 'Åland Islands',
  CC: 'Cocos (Keeling) Islands',
  CK: 'Cook Islands',
  CX: 'Christmas Island',
  EH: 'Western Sahara',
  FO: 'Faroe Islands',
  GG: 'Guernsey',
  GU: 'Guam',
  IM: 'Isle of Man',
  JE: 'Jersey',
  IO: 'British Indian Ocean Territory',
  KI: 'Kiribati',
  MH: 'Marshall Islands',
  MP: 'Northern Mariana Islands',
  NF: 'Norfolk Island',
  NR: 'Nauru',
  NU: 'Niue',
  PM: 'Saint Pierre and Miquelon',
  PR: 'Puerto Rico',
  PS: 'Palestine',
  SJ: 'Svalbard and Jan Mayen',
  SS: 'South Sudan',
  TA: 'Tristan da Cunha',
  TK: 'Tokelau',
  TV: 'Tuvalu',
  VA: 'Holy See',
  VI: 'Virgin Islands',
  WF: 'Wallis and Futuna'
};
const TUI_KOREAN_LANGUAGE_CORE = {
  months: ['1월', '2월', '3월', '4월', '5월', '6월', '7월', '8월', '9월', '10월', '11월', '12월'],
  close: '닫다',
  clear: '필드 지우기',
  nothingFoundMessage: '아무것도 발견되지 않았습니다',
  defaultErrorMessage: '값이 잘못되었습니다',
  spinTexts: ['이전의', '다음'],
  shortWeekDays: ['월요일', '화요일', '수요일', '목요일', '금요일', '토요일', '일요일'],
  countries: TUI_KOREAN_LANGUAGE_COUNTRIES
};
const TUI_KOREAN_LANGUAGE_KIT = {
  cancel: '취소',
  done: '완료',
  more: '더',
  otherDate: '다른 날짜',
  showAll: '모두 보기',
  hide: '숨다',
  mobileCalendarTexts: ['요일을 선택하세요', '범위를 선택하세요', '요일을 선택하세요'],
  range: ['~에서', '에게'],
  countTexts: ['을 더한', '마이너스'],
  time: {
    'HH:MM': 'HH:MM',
    'HH:MM AA': 'HH:MM AA',
    'HH:MM:SS': 'HH:MM:SS',
    'HH:MM:SS AA': 'HH:MM:SS AA',
    'HH:MM:SS.MSS': 'HH:MM:SS.MSS',
    'HH:MM:SS.MSS AA': 'HH:MM:SS.MSS AA'
  },
  dateTexts: {
    DMY: 'dd.mm.yyyy',
    MDY: 'mm.dd.yyyy',
    YMD: 'yyyy.mm.dd'
  },
  digitalInformationUnits: ['B', 'KiB', 'MiB'],
  passwordTexts: ['비밀번호 표시', '비밀번호 숨기기'],
  copyTexts: ['복사', '복사됨'],
  shortCalendarMonths: ['1월', '2월', '3월', '4월', '5월', '6월', '7월', '8월', '9월', '10월', '11월', '12월'],
  pagination: ['이전 페이지', '다음 페이지'],
  fileTexts: {
    loadingError: '업로드 실패',
    preview: '시사',
    remove: '제거하다'
  },
  inputFileTexts: {
    defaultLabelSingle: '또는 여기에 놓으세요',
    defaultLabelMultiple: '또는 여기에 놓으세요',
    defaultLinkSingle: '파일을 선택하세요',
    defaultLinkMultiple: '파일 선택',
    maxSizeRejectionReason: '파일이 다음보다 큽니다.',
    formatRejectionReason: '잘못된 파일 유형',
    drop: '여기에 파일을 놓으세요',
    dropMultiple: '여기에 파일을 놓으세요'
  },
  multiSelectTexts: {
    all: '모두 선택',
    none: '선택 안함'
  },
  confirm: {
    yes: '예',
    no: '아니요'
  },
  previewTexts: {
    rotate: '회전하다'
  },
  zoomTexts: {
    zoomOut: '축소',
    zoomIn: '확대하다',
    reset: '다시 놓기'
  },
  phoneSearch: '국가 또는 코드를 입력하세요'
};
const TUI_KOREAN_LANGUAGE_LAYOUT = {
  inputSearch: {
    popular: 'Popular',
    history: 'Recent',
    placeholder: 'Type query',
    hotkey: 'to search',
    all: 'All',
    empty: 'Nothing found'
  }
};
const TUI_KOREAN_LANGUAGE = {
  name: 'korean',
  ...TUI_KOREAN_LANGUAGE_CORE,
  ...TUI_KOREAN_LANGUAGE_KIT,
  ...TUI_KOREAN_LANGUAGE_ADDON_TABLE,
  ...TUI_KOREAN_LANGUAGE_ADDON_COMMERCE,
  ...TUI_KOREAN_LANGUAGE_ADDON_EDITOR,
  ...TUI_KOREAN_LANGUAGE_LAYOUT
};

/**
 * Generated bundle index. Do not edit.
 */

export { TUI_KOREAN_LANGUAGE, TUI_KOREAN_LANGUAGE_ADDON_COMMERCE, TUI_KOREAN_LANGUAGE_ADDON_EDITOR, TUI_KOREAN_LANGUAGE_ADDON_TABLE, TUI_KOREAN_LANGUAGE_CORE, TUI_KOREAN_LANGUAGE_COUNTRIES, TUI_KOREAN_LANGUAGE_KIT, TUI_KOREAN_LANGUAGE_LAYOUT };
